module.exports = __webpack_public_path__ + "img/noCreate.d7e5689d.png";